import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import { clone } from 'ramda'
import moment from 'moment'
import PaymentRemindersActions, {
  PaymentRemindersRedux,
  PaymentRemindersTypes,
} from '../Redux/PaymentRemindersRedux'
import { notificationSuccess, notificationFail } from '../Redux/NotificationActions'

const paymentRemindersCRUDObservable = createCRUDObservable({
  mainRedux: PaymentRemindersRedux,
  reduxPath: 'payment_reminders',
})

const sendReminderEpic = (action$, store, { Api }) => (
  action$.ofType(PaymentRemindersTypes.sendOneRequest)
    .mergeMap(({ studentId }) => (
      Observable
        .fromPromise(Api.payment_reminders.sendOne(studentId)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            const { error } = response

            return [
              PaymentRemindersActions.sendOneError(error),
              notificationFail(error),
            ]
          }

          const paymentReminders = clone(store.getState().payment_reminders.get.results.data)
          const cardChangedIndex =
            paymentReminders.findIndex(reminder => reminder.student.id === studentId)
          paymentReminders[cardChangedIndex].last_sent_at = moment().format('YYYY-MM-DD HH:mm:SS')

          return [
            PaymentRemindersActions.sendOneSuccess(paymentReminders),
            notificationSuccess('Recordatorio enviado exitosamente'),
          ]
        })
    ))
)

const getAllRemindersEpic = (action$, store, { Api }) => (
  action$.ofType(PaymentRemindersTypes.getAllRequest)
    .mergeMap(({ centerId, queries }) => (
      Observable
        .fromPromise(Api.payment_reminders.getAll(centerId, queries)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            return [
              PaymentRemindersActions.getAllError(response.error),
            ]
          }

          return [
            PaymentRemindersActions.getAllSuccess(response.data),
          ]
        })
    ))
)

const sendAllReminderEpic = (action$, store, { Api }) => (
  action$.ofType(PaymentRemindersTypes.sendAllRequest)
    .mergeMap(({ centerId }) => (
      Observable
        .fromPromise(Api.payment_reminders.sendAll(centerId)
          .then(response => response)
          .catch(err => err))
        .flatMap((response) => {
          const { status } = response

          if (!(status >= 200 && status < 300)) {
            const { error } = response

            return [
              PaymentRemindersActions.sendAllError(error),
              notificationFail(error),
            ]
          }

          let paymentReminders = clone(store.getState().payment_reminders.get.results.data)
          paymentReminders = paymentReminders.map((reminder) => {
            const reminderClone = { ...reminder }

            reminderClone.last_sent_at = moment().format('YYYY-MM-DD HH:mm:SS')

            return reminderClone
          })

          return [
            PaymentRemindersActions.sendAllSuccess(paymentReminders),
            notificationSuccess('Recordatorios enviados exitosamente'),
          ]
        })
    ))
)

export const paymentRemindersObservers = Object.assign({}, paymentRemindersCRUDObservable.observers,
  {
    sendReminderEpic,
  },
)

export const paymentRemindersEpic = combineEpics(
  paymentRemindersCRUDObservable.epic,
  sendReminderEpic,
  sendAllReminderEpic,
  getAllRemindersEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/PaymentRemindersObservable.js